import { createStore } from 'vuex'
import { signOut } from 'aws-amplify/auth'

const EMAIL_STORAGE_KEY = 'rcs_user_email'

function readStoredEmail() {
  try {
    return localStorage.getItem(EMAIL_STORAGE_KEY) || ''
  } catch (error) {
    return ''
  }
}

export default createStore({
  state: {
    user: {
      email: readStoredEmail()
    }
  },
  getters: {
    userEmail: (state) => state.user.email,
    isLoggedIn: (state) => Boolean(state.user.email)
  },
  mutations: {
    SET_USER_EMAIL(state, email) {
      state.user.email = email || ''
      try {
        if (state.user.email) {
          localStorage.setItem(EMAIL_STORAGE_KEY, state.user.email)
        } else {
          localStorage.removeItem(EMAIL_STORAGE_KEY)
        }
      } catch (error) {
        // Ignore storage errors (private mode, blocked storage, etc.)
      }
    },
    CLEAR_USER(state) {
      state.user.email = ''
      try {
        localStorage.removeItem(EMAIL_STORAGE_KEY)
      } catch (error) {
        // Ignore storage errors
      }
    }
  },
  actions: {
    login({ commit }, email) {
      commit('SET_USER_EMAIL', email)
    },
    async logout({ commit }) {
      try {
        await signOut()
      } catch (error) {
        console.error('Sign out failed:', error)
      }
      commit('CLEAR_USER')
    }
  },
  modules: {
  }
})
